import React from 'react'
import styled from 'styled-components'

function Referencias({ items, backgroundColor, color }) {
    const listItems = items.map((item,index) =>
        <li key={index}>{item}</li>
    );
    return (
        <Wrapper backgroundColor={backgroundColor}>
            <Subtittle>Referencias</Subtittle>
            <List backgroundColor={backgroundColor} color={color}>
                {listItems}
            </List>
        </Wrapper>
    )
}

export default Referencias

const Wrapper = styled.div`
    box-sizing: border-box;
    display:flex;
    flex-direction:column;
    width:100%;
    background-color: ${props=> props.backgroundColor ? props.backgroundColor : 'var(--color-morado-oscuro)'};
    padding-top: 32px;
    padding-bottom: 32px;
`;

const Subtittle = styled.h2`
    text-align:left;
    padding-left:32px;
    color: var(--color-blanco);
`;

const List = styled.ul`
    list-style:none;
    background-color: ${props=> props.backgroundColor ? props.backgroundColor : 'var(--color-morado-oscuro)'};
    li{
        color: ${props=> props.color ? props.color : 'var(--color-blanco)'};
        font-size:0.6em;
    }
`;